/* istanbul ignore file */
import { MouseEvent, useCallback, useMemo } from 'react'
import classNames from 'classnames'
import { Listing } from 'graphql/types'
import { toShortPrice } from 'lib/number'
import OverlayView from './OverlayView'
import styles from './Marker.module.scss'

interface CustomMarkerProps {
  map?: google.maps.Map
  onClick: (e: MouseEvent<HTMLButtonElement>, listing: Listing) => void
  listing?: Pick<Listing, 'id' | 'address' | 'price'>
  selected?: boolean
}

const Marker = ({ map, onClick, listing, selected }: CustomMarkerProps) => {
  const price = useMemo(() => {
    return `R$${toShortPrice(listing?.price as number)}`
  }, [listing])

  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      onClick(e, listing as Listing)
    },
    [onClick, listing],
  )

  const markerClasses = classNames(styles.ecMapMarker, {
    [styles.ecMapMarkerSelected]: selected,
  })

  if (map) {
    return (
      <OverlayView
        position={{
          lat: listing?.address?.lat as number,
          lng: listing?.address?.lng as number,
        }}
        map={map}
        zIndex={selected ? 999 : 0}
      >
        <button type="button" onClick={handleClick} className={markerClasses}>
          {price}
        </button>
      </OverlayView>
    )
  }

  return null
}

export default Marker
